export default "__VITE_ASSET__CeJK6ySq__"